/**
 * mk-motion.js — premium luxury motion (performance-first)
 *
 * - Opacity + transform only (no blur / scroll hijack)
 * - Auto-reveal common sections sitewide
 * - Auto-stagger for [data-mk-stagger]
 * - Media scale-in for .rc tiles
 * - Desktop-only light chapter parallax
 * - Respects prefers-reduced-motion
 */
(function () {
  'use strict';

  var root = document.documentElement;
  var body = document.body;
  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var motionAttr =
    root.getAttribute('data-mk-motion') ||
    (body && body.getAttribute('data-mk-motion'));
  var motionEnabled = motionAttr !== 'false' && !reduceMotion;

  var coarse =
    (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) ||
    (window.matchMedia && window.matchMedia('(max-width: 768px)').matches);

  /* Tag common blocks so motion works across the whole store */
  function autoTag() {
    var selectors = [
      '.mk-compare__hero .mk-wrap > *',
      '.mk-compare-card',
      '.mk-compare__sec-head',
      '.mk-compare-table-wrap',
      '.mk-footer__brand',
      '.mk-footer__col',
      '.mk-cta__panel',
      '.mk-cta__copy > *',
      '.mk-roles__card',
      '.mk-box-sec .mk-display',
      '.mk-box-sec .mk-lede',
      '.mk-spec-sec .mk-display',
      '.mks-life__intro',
      '.mks-life__split',
      '.mks-life__pair-item',
      '.mks-life__full',
      '.mks-feat__item',
      '.mks-inbox__item',
      '.mk-faq__group'
    ];
    for (var s = 0; s < selectors.length; s++) {
      var nodes = document.querySelectorAll(selectors[s]);
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        if (
          el.classList.contains('r') ||
          el.classList.contains('rc') ||
          el.classList.contains('reveal') ||
          el.closest('noscript')
        ) {
          continue;
        }
        el.classList.add('r');
      }
    }

    var mosaics = document.querySelectorAll('.mk-mosaic');
    for (var m = 0; m < mosaics.length; m++) {
      if (!mosaics[m].hasAttribute('data-mk-stagger')) {
        mosaics[m].setAttribute('data-mk-stagger', '0.06');
      }
    }
    var compareGrids = document.querySelectorAll('.mk-compare__cards-grid');
    for (var c = 0; c < compareGrids.length; c++) {
      if (!compareGrids[c].hasAttribute('data-mk-stagger')) {
        compareGrids[c].setAttribute('data-mk-stagger', '0.08');
      }
    }
    var footTops = document.querySelectorAll('.mk-footer__top');
    for (var f = 0; f < footTops.length; f++) {
      if (!footTops[f].hasAttribute('data-mk-stagger')) {
        footTops[f].setAttribute('data-mk-stagger', '0.06');
      }
    }
  }

  function applyStagger() {
    var groups = document.querySelectorAll('[data-mk-stagger]');
    for (var g = 0; g < groups.length; g++) {
      var group = groups[g];
      var step = parseFloat(group.getAttribute('data-mk-stagger')) || 0.06;
      if (coarse) step = Math.min(step, 0.05);
      var kids = [];
      var children = group.children;
      for (var c = 0; c < children.length; c++) {
        var child = children[c];
        if (
          child.classList &&
          (child.classList.contains('r') ||
            child.classList.contains('rc') ||
            child.classList.contains('reveal'))
        ) {
          kids.push(child);
        }
      }
      /* mosaic tiles wrap .rc inside .mk-tile */
      if (!kids.length) {
        var nested = group.querySelectorAll('.r, .rc, .reveal');
        for (var n = 0; n < nested.length; n++) kids.push(nested[n]);
      }
      var max = coarse ? 6 : 10;
      for (var i = 0; i < kids.length && i < max; i++) {
        if (!kids[i].style.getPropertyValue('--d')) {
          kids[i].style.setProperty('--d', (i * step).toFixed(2) + 's');
        }
      }
    }
  }

  autoTag();
  var reveals = Array.prototype.slice.call(document.querySelectorAll('.r, .rc, .reveal'));

  function revealInView() {
    var vh = window.innerHeight || root.clientHeight;
    for (var i = 0; i < reveals.length; i++) {
      var el = reveals[i];
      if (el.classList.contains('in')) continue;
      var r = el.getBoundingClientRect();
      if (r.top < vh * 0.96 && r.bottom > 0) el.classList.add('in');
    }
  }

  function revealAll() {
    for (var i = 0; i < reveals.length; i++) reveals[i].classList.add('in');
  }

  if (!motionEnabled || !reveals.length) {
    revealAll();
  } else {
    applyStagger();
    revealInView();
    root.classList.add('js-motion');
    if (coarse) root.classList.add('js-motion--touch');

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            var entry = entries[i];
            if (entry.isIntersecting) {
              entry.target.classList.add('in');
              io.unobserve(entry.target);
            }
          }
        },
        {
          threshold: coarse ? 0.06 : 0.12,
          rootMargin: coarse ? '0px 0px -2% 0px' : '0px 0px -8% 0px'
        }
      );
      for (var i = 0; i < reveals.length; i++) {
        if (!reveals[i].classList.contains('in')) io.observe(reveals[i]);
      }
    } else {
      revealAll();
    }

    window.setTimeout(function () {
      var left = document.querySelectorAll('.r:not(.in), .rc:not(.in), .reveal:not(.in)');
      for (var j = 0; j < left.length; j++) left[j].classList.add('in');
    }, 1600);
  }

  /* ---------- rail + sticky nav + desktop-only light parallax ---------- */
  var railFill = document.getElementById('mk-rail-fill');
  var nav = document.querySelector('.mk-nav') || document.querySelector('[data-mk-nav]');
  var chapterBgs =
    motionEnabled && !coarse
      ? Array.prototype.slice.call(
          document.querySelectorAll('.mk-chapter__bg[data-parallax], .mk-chapter__bg')
        )
      : [];
  var ticking = false;

  function onScroll() {
    var y = window.scrollY || window.pageYOffset || 0;
    var vh = window.innerHeight || root.clientHeight;
    var max = root.scrollHeight - vh;

    if (railFill) {
      railFill.style.height = (max > 0 ? (y / max) * 100 : 0) + '%';
    }
    if (nav) {
      nav.classList.toggle('stuck', y > 72);
    }

    if (chapterBgs.length) {
      for (var i = 0; i < chapterBgs.length; i++) {
        var el = chapterBgs[i];
        var parent = el.closest('.mk-chapter');
        if (!parent) continue;
        var r = parent.getBoundingClientRect();
        if (r.bottom < -100 || r.top > vh + 100) continue;
        var mid = (r.top + r.height * 0.5 - vh * 0.5) / vh;
        el.style.transform = 'translate3d(0,' + (mid * -16).toFixed(1) + 'px,0)';
      }
    }

    ticking = false;
  }

  function requestTick() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(onScroll);
    }
  }

  window.addEventListener('scroll', requestTick, { passive: true });
  window.addEventListener('resize', requestTick, { passive: true });
  onScroll();
})();
